/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PrivateImport } from './routes/_private'
import { Route as IndexImport } from './routes/index'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as PrivateTripsIndexImport } from './routes/_private/trips/index'
import { Route as PrivateTripsIdIndexImport } from './routes/_private/trips/$id/index'
import { Route as PrivateTripsIdScoutingNotesNewImport } from './routes/_private/trips/$id/scouting-notes/new'
import { Route as PrivateTripsIdCollectionsNewImport } from './routes/_private/trips/$id/collections/new'
import { Route as PrivateTripsIdSpeciesSpeciesIdIndexImport } from './routes/_private/trips/$id/species/$speciesId/index'
import { Route as PrivateTripsIdScoutingNotesScoutingNoteIdIndexImport } from './routes/_private/trips/$id/scouting-notes/$scoutingNoteId/index'
import { Route as PrivateTripsIdCollectionsCollectionIdIndexImport } from './routes/_private/trips/$id/collections/$collectionId/index'
import { Route as PrivateTripsIdScoutingNotesScoutingNoteIdEditImport } from './routes/_private/trips/$id/scouting-notes/$scoutingNoteId/edit'
import { Route as PrivateTripsIdCollectionsCollectionIdEditImport } from './routes/_private/trips/$id/collections/$collectionId/edit'

// Create/Update Routes

const PrivateRoute = PrivateImport.update({
  id: '/_private',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any)

const PrivateTripsIndexRoute = PrivateTripsIndexImport.update({
  id: '/trips/',
  path: '/trips/',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateTripsIdIndexRoute = PrivateTripsIdIndexImport.update({
  id: '/trips/$id/',
  path: '/trips/$id/',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateTripsIdScoutingNotesNewRoute =
  PrivateTripsIdScoutingNotesNewImport.update({
    id: '/trips/$id/scouting-notes/new',
    path: '/trips/$id/scouting-notes/new',
    getParentRoute: () => PrivateRoute,
  } as any)

const PrivateTripsIdCollectionsNewRoute =
  PrivateTripsIdCollectionsNewImport.update({
    id: '/trips/$id/collections/new',
    path: '/trips/$id/collections/new',
    getParentRoute: () => PrivateRoute,
  } as any)

const PrivateTripsIdSpeciesSpeciesIdIndexRoute =
  PrivateTripsIdSpeciesSpeciesIdIndexImport.update({
    id: '/trips/$id/species/$speciesId/',
    path: '/trips/$id/species/$speciesId/',
    getParentRoute: () => PrivateRoute,
  } as any)

const PrivateTripsIdScoutingNotesScoutingNoteIdIndexRoute =
  PrivateTripsIdScoutingNotesScoutingNoteIdIndexImport.update({
    id: '/trips/$id/scouting-notes/$scoutingNoteId/',
    path: '/trips/$id/scouting-notes/$scoutingNoteId/',
    getParentRoute: () => PrivateRoute,
  } as any)

const PrivateTripsIdCollectionsCollectionIdIndexRoute =
  PrivateTripsIdCollectionsCollectionIdIndexImport.update({
    id: '/trips/$id/collections/$collectionId/',
    path: '/trips/$id/collections/$collectionId/',
    getParentRoute: () => PrivateRoute,
  } as any)

const PrivateTripsIdScoutingNotesScoutingNoteIdEditRoute =
  PrivateTripsIdScoutingNotesScoutingNoteIdEditImport.update({
    id: '/trips/$id/scouting-notes/$scoutingNoteId/edit',
    path: '/trips/$id/scouting-notes/$scoutingNoteId/edit',
    getParentRoute: () => PrivateRoute,
  } as any)

const PrivateTripsIdCollectionsCollectionIdEditRoute =
  PrivateTripsIdCollectionsCollectionIdEditImport.update({
    id: '/trips/$id/collections/$collectionId/edit',
    path: '/trips/$id/collections/$collectionId/edit',
    getParentRoute: () => PrivateRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateImport
      parentRoute: typeof rootRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/_private/trips/': {
      id: '/_private/trips/'
      path: '/trips'
      fullPath: '/trips'
      preLoaderRoute: typeof PrivateTripsIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_private/trips/$id/': {
      id: '/_private/trips/$id/'
      path: '/trips/$id'
      fullPath: '/trips/$id'
      preLoaderRoute: typeof PrivateTripsIdIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_private/trips/$id/collections/new': {
      id: '/_private/trips/$id/collections/new'
      path: '/trips/$id/collections/new'
      fullPath: '/trips/$id/collections/new'
      preLoaderRoute: typeof PrivateTripsIdCollectionsNewImport
      parentRoute: typeof PrivateImport
    }
    '/_private/trips/$id/scouting-notes/new': {
      id: '/_private/trips/$id/scouting-notes/new'
      path: '/trips/$id/scouting-notes/new'
      fullPath: '/trips/$id/scouting-notes/new'
      preLoaderRoute: typeof PrivateTripsIdScoutingNotesNewImport
      parentRoute: typeof PrivateImport
    }
    '/_private/trips/$id/collections/$collectionId/edit': {
      id: '/_private/trips/$id/collections/$collectionId/edit'
      path: '/trips/$id/collections/$collectionId/edit'
      fullPath: '/trips/$id/collections/$collectionId/edit'
      preLoaderRoute: typeof PrivateTripsIdCollectionsCollectionIdEditImport
      parentRoute: typeof PrivateImport
    }
    '/_private/trips/$id/scouting-notes/$scoutingNoteId/edit': {
      id: '/_private/trips/$id/scouting-notes/$scoutingNoteId/edit'
      path: '/trips/$id/scouting-notes/$scoutingNoteId/edit'
      fullPath: '/trips/$id/scouting-notes/$scoutingNoteId/edit'
      preLoaderRoute: typeof PrivateTripsIdScoutingNotesScoutingNoteIdEditImport
      parentRoute: typeof PrivateImport
    }
    '/_private/trips/$id/collections/$collectionId/': {
      id: '/_private/trips/$id/collections/$collectionId/'
      path: '/trips/$id/collections/$collectionId'
      fullPath: '/trips/$id/collections/$collectionId'
      preLoaderRoute: typeof PrivateTripsIdCollectionsCollectionIdIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_private/trips/$id/scouting-notes/$scoutingNoteId/': {
      id: '/_private/trips/$id/scouting-notes/$scoutingNoteId/'
      path: '/trips/$id/scouting-notes/$scoutingNoteId'
      fullPath: '/trips/$id/scouting-notes/$scoutingNoteId'
      preLoaderRoute: typeof PrivateTripsIdScoutingNotesScoutingNoteIdIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_private/trips/$id/species/$speciesId/': {
      id: '/_private/trips/$id/species/$speciesId/'
      path: '/trips/$id/species/$speciesId'
      fullPath: '/trips/$id/species/$speciesId'
      preLoaderRoute: typeof PrivateTripsIdSpeciesSpeciesIdIndexImport
      parentRoute: typeof PrivateImport
    }
  }
}

// Create and export the route tree

interface PrivateRouteChildren {
  PrivateTripsIndexRoute: typeof PrivateTripsIndexRoute
  PrivateTripsIdIndexRoute: typeof PrivateTripsIdIndexRoute
  PrivateTripsIdCollectionsNewRoute: typeof PrivateTripsIdCollectionsNewRoute
  PrivateTripsIdScoutingNotesNewRoute: typeof PrivateTripsIdScoutingNotesNewRoute
  PrivateTripsIdCollectionsCollectionIdEditRoute: typeof PrivateTripsIdCollectionsCollectionIdEditRoute
  PrivateTripsIdScoutingNotesScoutingNoteIdEditRoute: typeof PrivateTripsIdScoutingNotesScoutingNoteIdEditRoute
  PrivateTripsIdCollectionsCollectionIdIndexRoute: typeof PrivateTripsIdCollectionsCollectionIdIndexRoute
  PrivateTripsIdScoutingNotesScoutingNoteIdIndexRoute: typeof PrivateTripsIdScoutingNotesScoutingNoteIdIndexRoute
  PrivateTripsIdSpeciesSpeciesIdIndexRoute: typeof PrivateTripsIdSpeciesSpeciesIdIndexRoute
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateTripsIndexRoute: PrivateTripsIndexRoute,
  PrivateTripsIdIndexRoute: PrivateTripsIdIndexRoute,
  PrivateTripsIdCollectionsNewRoute: PrivateTripsIdCollectionsNewRoute,
  PrivateTripsIdScoutingNotesNewRoute: PrivateTripsIdScoutingNotesNewRoute,
  PrivateTripsIdCollectionsCollectionIdEditRoute:
    PrivateTripsIdCollectionsCollectionIdEditRoute,
  PrivateTripsIdScoutingNotesScoutingNoteIdEditRoute:
    PrivateTripsIdScoutingNotesScoutingNoteIdEditRoute,
  PrivateTripsIdCollectionsCollectionIdIndexRoute:
    PrivateTripsIdCollectionsCollectionIdIndexRoute,
  PrivateTripsIdScoutingNotesScoutingNoteIdIndexRoute:
    PrivateTripsIdScoutingNotesScoutingNoteIdIndexRoute,
  PrivateTripsIdSpeciesSpeciesIdIndexRoute:
    PrivateTripsIdSpeciesSpeciesIdIndexRoute,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof PrivateRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/trips': typeof PrivateTripsIndexRoute
  '/trips/$id': typeof PrivateTripsIdIndexRoute
  '/trips/$id/collections/new': typeof PrivateTripsIdCollectionsNewRoute
  '/trips/$id/scouting-notes/new': typeof PrivateTripsIdScoutingNotesNewRoute
  '/trips/$id/collections/$collectionId/edit': typeof PrivateTripsIdCollectionsCollectionIdEditRoute
  '/trips/$id/scouting-notes/$scoutingNoteId/edit': typeof PrivateTripsIdScoutingNotesScoutingNoteIdEditRoute
  '/trips/$id/collections/$collectionId': typeof PrivateTripsIdCollectionsCollectionIdIndexRoute
  '/trips/$id/scouting-notes/$scoutingNoteId': typeof PrivateTripsIdScoutingNotesScoutingNoteIdIndexRoute
  '/trips/$id/species/$speciesId': typeof PrivateTripsIdSpeciesSpeciesIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof PrivateRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/trips': typeof PrivateTripsIndexRoute
  '/trips/$id': typeof PrivateTripsIdIndexRoute
  '/trips/$id/collections/new': typeof PrivateTripsIdCollectionsNewRoute
  '/trips/$id/scouting-notes/new': typeof PrivateTripsIdScoutingNotesNewRoute
  '/trips/$id/collections/$collectionId/edit': typeof PrivateTripsIdCollectionsCollectionIdEditRoute
  '/trips/$id/scouting-notes/$scoutingNoteId/edit': typeof PrivateTripsIdScoutingNotesScoutingNoteIdEditRoute
  '/trips/$id/collections/$collectionId': typeof PrivateTripsIdCollectionsCollectionIdIndexRoute
  '/trips/$id/scouting-notes/$scoutingNoteId': typeof PrivateTripsIdScoutingNotesScoutingNoteIdIndexRoute
  '/trips/$id/species/$speciesId': typeof PrivateTripsIdSpeciesSpeciesIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_private': typeof PrivateRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/_private/trips/': typeof PrivateTripsIndexRoute
  '/_private/trips/$id/': typeof PrivateTripsIdIndexRoute
  '/_private/trips/$id/collections/new': typeof PrivateTripsIdCollectionsNewRoute
  '/_private/trips/$id/scouting-notes/new': typeof PrivateTripsIdScoutingNotesNewRoute
  '/_private/trips/$id/collections/$collectionId/edit': typeof PrivateTripsIdCollectionsCollectionIdEditRoute
  '/_private/trips/$id/scouting-notes/$scoutingNoteId/edit': typeof PrivateTripsIdScoutingNotesScoutingNoteIdEditRoute
  '/_private/trips/$id/collections/$collectionId/': typeof PrivateTripsIdCollectionsCollectionIdIndexRoute
  '/_private/trips/$id/scouting-notes/$scoutingNoteId/': typeof PrivateTripsIdScoutingNotesScoutingNoteIdIndexRoute
  '/_private/trips/$id/species/$speciesId/': typeof PrivateTripsIdSpeciesSpeciesIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/auth/login'
    | '/trips'
    | '/trips/$id'
    | '/trips/$id/collections/new'
    | '/trips/$id/scouting-notes/new'
    | '/trips/$id/collections/$collectionId/edit'
    | '/trips/$id/scouting-notes/$scoutingNoteId/edit'
    | '/trips/$id/collections/$collectionId'
    | '/trips/$id/scouting-notes/$scoutingNoteId'
    | '/trips/$id/species/$speciesId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/auth/login'
    | '/trips'
    | '/trips/$id'
    | '/trips/$id/collections/new'
    | '/trips/$id/scouting-notes/new'
    | '/trips/$id/collections/$collectionId/edit'
    | '/trips/$id/scouting-notes/$scoutingNoteId/edit'
    | '/trips/$id/collections/$collectionId'
    | '/trips/$id/scouting-notes/$scoutingNoteId'
    | '/trips/$id/species/$speciesId'
  id:
    | '__root__'
    | '/'
    | '/_private'
    | '/auth/login'
    | '/_private/trips/'
    | '/_private/trips/$id/'
    | '/_private/trips/$id/collections/new'
    | '/_private/trips/$id/scouting-notes/new'
    | '/_private/trips/$id/collections/$collectionId/edit'
    | '/_private/trips/$id/scouting-notes/$scoutingNoteId/edit'
    | '/_private/trips/$id/collections/$collectionId/'
    | '/_private/trips/$id/scouting-notes/$scoutingNoteId/'
    | '/_private/trips/$id/species/$speciesId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivateRoute: typeof PrivateRouteWithChildren
  AuthLoginRoute: typeof AuthLoginRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivateRoute: PrivateRouteWithChildren,
  AuthLoginRoute: AuthLoginRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_private",
        "/auth/login"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_private": {
      "filePath": "_private.tsx",
      "children": [
        "/_private/trips/",
        "/_private/trips/$id/",
        "/_private/trips/$id/collections/new",
        "/_private/trips/$id/scouting-notes/new",
        "/_private/trips/$id/collections/$collectionId/edit",
        "/_private/trips/$id/scouting-notes/$scoutingNoteId/edit",
        "/_private/trips/$id/collections/$collectionId/",
        "/_private/trips/$id/scouting-notes/$scoutingNoteId/",
        "/_private/trips/$id/species/$speciesId/"
      ]
    },
    "/auth/login": {
      "filePath": "auth/login.tsx"
    },
    "/_private/trips/": {
      "filePath": "_private/trips/index.tsx",
      "parent": "/_private"
    },
    "/_private/trips/$id/": {
      "filePath": "_private/trips/$id/index.tsx",
      "parent": "/_private"
    },
    "/_private/trips/$id/collections/new": {
      "filePath": "_private/trips/$id/collections/new.tsx",
      "parent": "/_private"
    },
    "/_private/trips/$id/scouting-notes/new": {
      "filePath": "_private/trips/$id/scouting-notes/new.tsx",
      "parent": "/_private"
    },
    "/_private/trips/$id/collections/$collectionId/edit": {
      "filePath": "_private/trips/$id/collections/$collectionId/edit.tsx",
      "parent": "/_private"
    },
    "/_private/trips/$id/scouting-notes/$scoutingNoteId/edit": {
      "filePath": "_private/trips/$id/scouting-notes/$scoutingNoteId/edit.tsx",
      "parent": "/_private"
    },
    "/_private/trips/$id/collections/$collectionId/": {
      "filePath": "_private/trips/$id/collections/$collectionId/index.tsx",
      "parent": "/_private"
    },
    "/_private/trips/$id/scouting-notes/$scoutingNoteId/": {
      "filePath": "_private/trips/$id/scouting-notes/$scoutingNoteId/index.tsx",
      "parent": "/_private"
    },
    "/_private/trips/$id/species/$speciesId/": {
      "filePath": "_private/trips/$id/species/$speciesId/index.tsx",
      "parent": "/_private"
    }
  }
}
ROUTE_MANIFEST_END */
